// ---------------------------------------------------------------------------
// Private games are out of scope for the BetArabia integration (Sept 2026).
// Players must not see anything related to them.
//
// This flag hides every player-facing surface. Nothing is deleted: the
// PrivateGame page, the Dashboard panel, the invite-link modal and the
// service-layer calls all remain intact and compile as before. Flip this to
// true to bring the whole feature back in one edit.
//
// Gated surfaces (search for PRIVATE_GAMES_ENABLED to find them all):
//   App.js .......................... /privategame route -> redirect to /game
//   Dashboard.jsx ................... "Private Games" panel + its error state,
//                                     and the request itself
//   OngoingTable.jsx ................ "Private" tag and "Share Link" invite
//                                     button, desktop and mobile
// ---------------------------------------------------------------------------
export const PRIVATE_GAMES_ENABLED = false;
